import React, { useState } from "react";

import DatePickerField from "./DatePickerField";

const DatePickerGroup = (props) => {
  const propsStartDate = props.start_date && Date.parse(props.start_date);
  const propsEndDate = props.end_date && Date.parse(props.end_date);
  const [startDate, setStartDate] = useState(propsStartDate);
  const [endDate, setEndDate] = useState(propsEndDate);

  return (
    <>
      {props.label && (
        <label className="select-container__label">{props.label}</label>
      )}
      <div className="flex row">
        <div>
          <DatePickerField
            name={props.start_date_name}
            selectedDate={startDate}
            handleDateChange={(date) => setStartDate(date)}
            maxDate={endDate}
          />
        </div>
        <span className="select-container__label mr-1 ml-1 flex items-center pb-4">to</span>

        <div className="mr-4">
          <DatePickerField
            name={props.end_date_name}
            selectedDate={endDate}
            handleDateChange={(date) => setEndDate(date)}
            minDate={startDate}
          />
        </div>
      </div>
    </>
  );
};

export default DatePickerGroup;
